export default defineAppConfig({
  ui: {
    colors: {
      primary: 'primary',
      neutral: 'neutral',
      secondary: 'secondary',
    },
    container: {
      base: 'w-full max-w-[1980px] mx-auto px-0 sm:px-0 lg:px-0',
    },
    input: {
      slots: {
        base: 'h-12 rounded-xl text-base',
      },
    },
    button: {
      base: 'cursor-pointer',
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'text-white',
        },
        {
          color: 'secondary',
          variant: 'solid',
          class: 'text-black',
        },
      ],
      defaultVariants: {},
    },
    badge: {
      base: 'cursor-pointer',
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'dark:text-white',
        },
      ],
      defaultVariants: {},
    },
    selectMenu: {
      slots: {
        base: [
          'h-12 px-5 text-base gap-2 w-full rounded-xl border-0 appearance-none placeholder:text-dimmed focus:outline-none disabled:cursor-not-allowed disabled:opacity-75',
          'transition-colors',
        ],
        trailingIcon:
          'group-data-[state=open]:rotate-180 transition-transform duration-200',
        item: ['group text-base font-medium'],
      },
    },
  },
});
